
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M43.5 54a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-29a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h29zm-3.135-38.25l.185.358.31-.036c7.48-.814 12.726 2.117 12.955 8.52l.008.443c0 4.68-3.162 10.948-9.445 18.907l-.378.472V49a1 1 0 01-.82.984L43 50H15.005a1 1 0 01-1-.968l.01-.179 2.919-19.703-5.8-9.634a1 1 0 01.682-1.501L11.99 18h6.098l.014-.138.047-.174C23.164 4.112 33.86 3.472 40.365 15.75zM20.43 17.346l-.262.654H26a1 1 0 01.984.82L27 19a1 1 0 01-.82.984L26 20H13.758l5.075 8.425a1 1 0 01.143.49l-.01.172L16.161 48H42v-3.933a1 1 0 01.126-.486l.094-.14c6.417-7.989 9.603-14.161 9.603-18.406 0-5.528-4.552-7.926-11.698-6.85a1 1 0 01-1.049-.554C33.554 6.222 25.063 6.118 20.43 17.346zm27.46 7.414c.733 2.501-.965 6.402-4.974 11.953a1 1 0 01-1.622-1.171c3.65-5.052 5.168-8.542 4.677-10.22-.446-1.521-1.755-2.067-4.354-1.588a1 1 0 11-.362-1.967c3.503-.646 5.857.336 6.635 2.993z"}})])
          )
        }
      }
    